import NachWrapper from '../components/NachWrapper';
import PresentmentTabs from './components/PresentmentTabs';
import PresentmentFilterProvider from './context/PresenmentFilterProvider';

function Presentment() {
  return (
    <NachWrapper title="Presentment Dashboard">
      <PresentmentFilterProvider>
        <div className="presentment">
          <PresentmentTabs />
        </div>
      </PresentmentFilterProvider>
    </NachWrapper>
  );
}

export default Presentment;
